



























































































































































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Paciente } from '../../../../back/src/entity/Paciente';

import CustomDialog from '../CustomDialog.vue';
import TheConsultasAgendamentoIndividual from '../consultas/TheConsultasAgendamentoIndividual.vue';
import TheConsultasTabelaEmAndamento from '../consultas/TheConsultasTabelaEmAndamento.vue';
import TheConsultasTabelaAgendadas from '../consultas/TheConsultasTabelaAgendadas.vue';
import ConsultasFinalizadasNotasProntuarioTabela from '../consultas/ConsultasFinalizadasNotasProntuarioTabela.vue';
import NotasProntuarioForm from '../notas_prontuarios/NotasProntuarioForm.vue';
import {
  ConsultaPostFormData,
  TipoConsulta,
} from '../../../../back/src/types';
import { NotaProntuario } from '../../../../back/src/entity/NotaProntuario';

export default Vue.extend({
  name: 'ThePacientesDadosConsultasNotas',
  components: {
    CustomDialog,
    TheConsultasAgendamentoIndividual,
    TheConsultasTabelaEmAndamento,
    TheConsultasTabelaAgendadas,
    NotasProntuarioForm,
    ConsultasFinalizadasNotasProntuarioTabela,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    consultas: {
      type: Array as () => Consulta[],
    },
  },
  data() {
    return {
      loading: {
        iniciaNovaConsulta: false,
        notasProntuario: false,
      },
      notasProntuario: [],
      dialogAgendamento: false,
      dialogNotasProntuario: false,
      showConsultasEmAndamento: true,
      showConsultasAgendadas: true,
      showConsultasFinalizadas: true,
    };
  },
  computed: {
    consultasEmAndamento(): Consulta[] {
      return _.filter(
        this.consultas as Consulta[],
        consulta => !!consulta.started
          && !consulta.ended
          && !consulta.datetime_cancelamento,
      );
    },
    consultasAgendadas(): Consulta[] {
      return _.filter(
        this.consultas as Consulta[],
        consulta => !!consulta.datetime_agendamento
          && !consulta.datetime_cancelamento
          && !consulta.ended,
      );
    },
    consultasFinalizadas(): Consulta[] {
      return _.filter(
        this.consultas as Consulta[],
        consulta => !!consulta.ended && !consulta.datetime_cancelamento,
      );
    },
  },
  async mounted() {
    await this.buscaNotasProntuario();
  },
  methods: {
    novaConsulta(novaConsulta: Consulta) {
      this.$emit('novaConsulta', novaConsulta);
      this.dialogAgendamento = false;
    },
    onConsultaAlterada(consulta: Consulta) {
      const index = _.findIndex(
        this.consultas,
        (el: Consulta) => el.id === consulta.id,
      );
      if (index >= 0) {
        this.$set(this.consultas, index, consulta);
      }
    },
    notaProntuarioAlterada(notaAlterada: NotaProntuario) {
      // this.dialogNotasProntuario = false;
      const index = _.findIndex(
        this.notasProntuario,
        (el: NotaProntuario) => el.id === notaAlterada.id,
      );
      if (index >= 0) {
        this.notasProntuario.splice(index, 1, notaAlterada);
      }
    },
    novaNotaProntuario(novaNotaProntuario: NotaProntuario) {
      this.notasProntuario.push(novaNotaProntuario);
      this.dialogNotasProntuario = false;
    },
    cancelaConsulta(consulta: Consulta) {
      this.$emit('cancelaConsulta', consulta);
    },
    // eslint-disable-next-line func-names
    iniciaNovaConsultaDebounce: _.debounce(async function () {
      await this.iniciaNovaConsulta();
    }, 200),
    async iniciaNovaConsulta() {
      this.loading.iniciaNovaConsulta = true;
      const formData: ConsultaPostFormData = {
        tipo_consulta: TipoConsulta.P,
        paciente_id: this.paciente.id,
        gestacao_id: this.paciente.gestacao_atual
          ? this.paciente.gestacao_atual.id
          : null,
      };
      try {
        const response = await Requester.consulta.criaConsulta(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', {
            color: 'error',
            text: response.errors,
          });
        } else {
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Nova consulta iniciada com sucesso!',
          });
          this.$router.push({
            name: 'ConsultasAtender',
            params: { consultaId: response.data.id },
          });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.iniciaNovaConsulta = false;
      }
    },
    async buscaNotasProntuario() {
      this.loading.notasProntuario = true;
      try {
        const response = await Requester.paciente.notasProntuario(this.paciente.id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', {
            color: 'error',
            text: response.errors,
          });
        } else {
          this.notasProntuario = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.notasProntuario = false;
      }
    },
  },
});
